/** @jsxRuntime classic */
/** @jsx jsx */

import { Spacer as ZinniaSpacer } from '@zapier/design-system';
import { css, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';

export interface SpacerProps {
  height?: number;
  width?: number;
  backgroundColor: string;
}

const Styles = labelStyles('Spacer', {
  root: (backgroundColor: string) => css({ backgroundColor }),
});

export function Spacer({ height, width, backgroundColor }: SpacerProps) {
  return (
    <div css={Styles.root(backgroundColor)}>
      <ZinniaSpacer height={height} width={width} />
    </div>
  );
}
